import { render, staticRenderFns } from "./club-points-history-table-row.vue?vue&type=template&id=532ea278&"
import script from "./club-points-history-table-row.vue?vue&type=script&lang=js&"
export * from "./club-points-history-table-row.vue?vue&type=script&lang=js&"
import style0 from "./club-points-history-table-row.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532ea278')) {
      api.createRecord('532ea278', component.options)
    } else {
      api.reload('532ea278', component.options)
    }
    module.hot.accept("./club-points-history-table-row.vue?vue&type=template&id=532ea278&", function () {
      api.rerender('532ea278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-table/club-points-history-table-row.vue"
export default component.exports